/**
 * Floating Menu Component
 */
export class FloatMenu {
    constructor() {
        this.container = null;
        this.menu = null;
        this.links = [];
        this.items = [];
        this.PIN_OFFSET = 100;
        this.SCROLL_OFFSET = 100;
    }

    init() {
        this.container = document.querySelector(".no-floating-container");
        this.menu = document.querySelector(".no-floating-menu");
        if (!this.container || !this.menu) return;

        gsap.registerPlugin(ScrollTrigger);
        this.initPin();
        this.initActiveStates();
        this.initScrollTo();
    }

    initPin() {
        ScrollTrigger.create({
            trigger: this.container,
            start: `top+=${this.PIN_OFFSET} top`,
            end: "bottom bottom",
            pin: this.menu,
            pinSpacing: false,
            anticipatePin: 1,
            invalidateOnRefresh: true,
        });
    }

    initActiveStates() {
        this.links = Array.from(
            this.menu.querySelectorAll(".no-floating-menu__link")
        );

        this.items = this.links
            .map((link) => {
                try {
                    const url = new URL(link.href, location.origin);
                    const hash = url.hash?.replace("#", "") || "";
                    if (!hash) return null;
                    const section = document.getElementById(hash);
                    if (!section) return null;
                    return { link, section, hash };
                } catch (e) {
                    return null;
                }
            })
            .filter(Boolean);

        const clearActive = () => {
            this.links.forEach((a) => a.classList.remove("--active"));
        };

        const setActive = (link) => {
            if (!link) return;
            clearActive();
            link.classList.add("--active");
        };

        this.items.forEach(({ link, section }) => {
            ScrollTrigger.create({
                trigger: section,
                start: `top+=${this.SCROLL_OFFSET} center`,
                end: `bottom center`,
                onEnter: () => setActive(link),
                onEnterBack: () => setActive(link),
                invalidateOnRefresh: true,
            });
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    }

    initScrollTo() {
        const scrollToSection = (el) => {
            const top =
                el.getBoundingClientRect().top +
                window.pageYOffset -
                this.SCROLL_OFFSET;
            window.scrollTo({ top, behavior: "smooth" });
        };

        this.links.forEach((a) => {
            a.addEventListener("click", (e) => {
                const hash = new URL(a.href, location.origin).hash.replace(
                    "#",
                    ""
                );
                const target = document.getElementById(hash);
                if (target) {
                    e.preventDefault();
                    scrollToSection(target);
                    const found = this.items.find((i) => i.hash === hash);
                    if (found) {
                        this.links.forEach((l) => l.classList.remove("--active"));
                        found.link.classList.add("--active");
                    }
                    history.replaceState(null, "", `#${hash}`);
                }
            });
        });

        window.addEventListener("load", () => ScrollTrigger.refresh());

        setTimeout(() => {
            const currentHash = location.hash?.replace("#", "");
            if (currentHash) {
                const target = document.getElementById(currentHash);
                if (target) {
                    scrollToSection(target);
                    const found = this.items.find(
                        (i) => i.hash === currentHash
                    );
                    if (found) {
                        this.links.forEach((l) =>
                            l.classList.remove("--active")
                        );
                        found.link.classList.add("--active");
                    }
                }
            }
        }, 300);
    }
}

